import type { GADataProps } from "@elements/GAData/GAData";
import type { MetaTagsProps } from "@elements/MetaTags/MetaTags";
import type { PageMetaDataValues } from "@typings/PageMetaData";

export function Tm90MetaData(): PageMetaDataValues {
  const metaTitle =
    "தமிழ்முரசு 90வது ஆண்டு விழா | சிங்கப்பூரின் தமிழ் பத்திரிகை மரபை கொண்டாடுவோம்";
  const metaDescription =
    "90 ஆண்டுகளாக தமிழ் முரசு சிங்கப்பூரில் தமிழ் வாசகர்களின் நம்பிக்கைக்குரிய பத்திரிகையாக இருந்துள்ளது. எங்கள் பயணத்தையும், கதைகளையும், நாயகர்களையும் அனுசரிக்கவும்.";

  const metaTags: MetaTagsProps = {
    title: metaTitle,
    description: metaDescription,
    slug: `tm-90`,
    keywords: [
      "தமிழ் முரசு 90, TM90, தமிழ் முரசு ஆண்டு விழா, சிங்கப்பூர் தமிழ் பத்திரிகை, தமிழ் முரசு வரலாறு, தமிழ் பத்திரிகை சிங்கப்பூர், தமிழ் முரசு மரபு",
    ],
  };

  const gaData: GADataProps = {
    level2: "tm90",
    title: `TM 90`,
    contentcat: 1,
    contenttype: undefined,
  };

  return {
    gaData,
    metaTags,
  };
}
